export enum ContractType {
  Insurance = 'INS',
  MaintenanceServicePlan = 'MSP',
}
